import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition} from '@angular/cdk/overlay';
import {ClickService} from '../../../core/services/click.service';
import {Subscription} from 'rxjs';
import {TileIcon} from '../../../shared/models/tile-icon';
import {IconPickerComponent} from '../icon-picker/icon-picker.component';

@Component({
  selector: 'motn-popover-icon-picker',
  templateUrl: './popover-icon-picker.component.html',
  styleUrls: ['./popover-icon-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    IconPickerComponent,
  ],
})
export class PopoverIconPickerComponent implements OnInit {
  @Input() icon: TileIcon = 'dot-circle';
  @Input() overlayPositions: ConnectedPosition[] = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'center',
    overlayY: 'bottom',
  }];

  @Output() clickedIcon$: EventEmitter<TileIcon> = new EventEmitter<TileIcon>();
  @Output() clickedOutsideMenu$: EventEmitter<null> = new EventEmitter<null>();

  clickSub: Subscription;


  constructor(
    private eRef: ElementRef,
    private clickService: ClickService,
  ) {
  }


  ngOnInit(): void {
    this.clickSub = this.clickService.click$.subscribe(
      ($el) => {
        if (!this.eRef.nativeElement.contains($el)) {
          this.clickedOutsideMenu$.emit(null);
        }
      },
    );
  }


  onClick(icon: TileIcon) {
    this.clickedIcon$.emit(icon);
  }
}
